import React, { useEffect, useState } from 'react';

import { breakpoints } from '@edx/paragon';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import {
  DefaultLargeLayout,
  DefaultMediumLayout,
  DefaultSmallLayout,
} from './components/default-layout';
import {
  ImageExtraSmallLayout,
  ImageLargeLayout,
  ImageMediumLayout,
  ImageSmallLayout,
} from './components/image-layout';
import {
  AuthLargeLayout,
  AuthMediumLayout,
  AuthSmallLayout,
} from './components/welcome-page-layout';
import { DEFAULT_LAYOUT, IMAGE_LAYOUT } from './data/constants';

const BaseContainer = ({ children, showWelcomeBanner, username }) => {
  const [baseContainerVersion, setBaseContainerVersion] =
    useState(DEFAULT_LAYOUT);

  useEffect(() => {
    const initRebrandExperiment = () => {
      if (window.experiments?.rebrandExperiment) {
        setBaseContainerVersion(
          window.experiments?.rebrandExperiment?.variation,
        );
      } else {
        window.experiments = window.experiments || {};
        window.experiments.rebrandExperiment = {};
        window.experiments.rebrandExperiment.handleLoaded = () => {
          setBaseContainerVersion(
            window.experiments?.rebrandExperiment?.variation,
          );
        };
      }
    };
    initRebrandExperiment();
  }, []);

  if (baseContainerVersion === IMAGE_LAYOUT) {
    return (
      <div className="lg:tw-bg-hero-desktop sm:tw-bg-hero-tablet tw-bg-cover tw-bg-no-repeat tw-bg-center tw-min-h-screen">
        <div className="tw-container tw-flex tw-justify-center tw-items-center tw-min-h-screen">
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className="lg:tw-bg-hero-desktop tw-bg-hero-tablet tw-bg-cover tw-bg-no-repeat lg:tw-bg-center tw-bg-right">
      <div className="tw-container tw-flex tw-justify-center tw-items-center tw-min-h-screen">
        {children}
      </div>
    </div>
  );
};

BaseContainer.defaultProps = {
  showWelcomeBanner: false,
  username: null,
};

BaseContainer.propTypes = {
  children: PropTypes.node.isRequired,
  showWelcomeBanner: PropTypes.bool,
  username: PropTypes.string,
};

export default BaseContainer;
